export const HR_FILTER_FORM_DEFAULT_PARAMS = Object.freeze({
  createdAt: undefined,
  updatedAt: undefined,
  numOfDays: undefined,
  datesFromTo: undefined,
});

export const HR_DEFAULT_PARAMS = Object.freeze({
  offset: '1',
  limit: '10',
  type: 'REQUEST',

  // Filters
  company: 'all',
  email: undefined,
  firstName: undefined,
  lastName: undefined,
  status: undefined,
  typeOfLeave: undefined,

  // Sorters
  sortFirstName: undefined,
  sortLastName: undefined,
  sortTypeOfLeave: undefined,
  sortStatus: undefined,
  sortCreatedAt: undefined,

  ...HR_FILTER_FORM_DEFAULT_PARAMS,
});

export const HR_COLUMNS_DEFAULT_PARAMS = Object.freeze({
  email: undefined,
  firstName: undefined,
  lastName: undefined,
  status: undefined,
  typeOfLeave: undefined,
});
